import * as React from "react"
import { renderMarkdown } from "../aegis/markdown"
import { usePublicShareSettings } from "./public_share_settings"

const SPLASH_HEADINGS: Record<number, number> = { 1: 28, 2: 22, 3: 18, 4: 16, 5: 15, 6: 14 }

/** First screen on the public share page. */
export function PublicSplash() {
  const splash = usePublicShareSettings()?.splash?.trim() ?? ""
  const [open, setOpen] = React.useState(true)
  if (!open || splash === "") return null

  return (
    <div className="public-splash" role="dialog" aria-modal="true" aria-label="Splash">
      <div className="public-splash__card">
        <div className="public-splash__body">
          {renderMarkdown(splash, undefined, { headingSizes: SPLASH_HEADINGS })}
        </div>
        <button type="button" className="public-splash__close" onClick={() => setOpen(false)}>
          Continue
        </button>
      </div>
    </div>
  )
}
